import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, inr } from "@/lib/api";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

const STEPS = ["NEW", "ACKNOWLEDGED", "PREPARING", "READY", "DELIVERED"];

export default function GuestOrdersPage() {
  const [orders, setOrders] = useState([]);
  const [reqs, setReqs] = useState([]);

  const fetchAll = async () => {
    const [o, r] = await Promise.all([http.get("/guest/orders"), http.get("/guest/my-service-requests")]);
    setOrders(o.data.orders);
    setReqs(r.data.requests);
  };
  useEffect(() => { fetchAll(); const t = setInterval(fetchAll, 4000); return () => clearInterval(t); }, []);

  return (
    <div className="min-h-screen pb-20" style={{ background: "var(--surface)" }}>
      <div className="max-w-lg mx-auto px-4 pt-6">
        <Link to="/guest/dashboard" data-testid="orders-back" className="flex items-center gap-1 text-sm mb-4" style={{ color: "var(--muted)" }}><ArrowLeft size={16} /> Back</Link>
        <div className="eyebrow mb-1">Live</div>
        <h1 className="font-serif text-4xl mb-6">My Orders</h1>

        <h2 className="font-serif text-2xl mb-3">Food</h2>
        {orders.length === 0 && <p className="text-sm mb-6" style={{ color: "var(--muted)" }}>No food orders yet.</p>}
        <div className="space-y-4 mb-8">
          {orders.map((o) => {
            const stepIdx = STEPS.indexOf(o.status);
            return (
              <div key={o.id} className="card" data-testid={`order-${o.order_number}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="font-serif text-xl">{o.order_number}</div>
                  <div className="badge-terracotta">{o.status}</div>
                </div>
                <div className="text-sm mb-3" style={{ color: "var(--muted)" }}>{o.items.map((i) => `${i.quantity}× ${i.item_name_snapshot}`).join(" · ")}</div>
                <div className="flex gap-1 mb-3">
                  {STEPS.map((s, i) => <div key={s} className="flex-1 h-1 rounded" style={{ background: i <= stepIdx && stepIdx >= 0 ? "var(--terracotta)" : "var(--border)" }} />)}
                </div>
                <div className="flex justify-between text-sm">
                  <span style={{ color: "var(--muted)" }}>{new Date(o.created_at).toLocaleTimeString()}</span>
                  <span className="font-medium">{inr(o.total)}</span>
                </div>
              </div>
            );
          })}
        </div>

        <h2 className="font-serif text-2xl mb-3">Services</h2>
        {reqs.length === 0 && <p className="text-sm" style={{ color: "var(--muted)" }}>No service requests yet.</p>}
        <div className="space-y-4">
          {reqs.map((r) => (
            <div key={r.id} className="card" data-testid={`svc-req-${r.id}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="font-serif text-xl">{r.service_name_snapshot} × {r.quantity}</div>
                <div className="badge-pine">{r.status}</div>
              </div>
              <div className="flex justify-between text-sm">
                <span style={{ color: "var(--muted)" }}>{new Date(r.requested_at).toLocaleTimeString()}</span>
                <span className="font-medium">{inr(r.total)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
